import api from '@/api'

export default {
  all: (filter) => api('get', '/company', filter),
  create: (data) => api('post', '/company', data),
  show: (id) => api('get', `/company/${id}`),
  delete: (id) => api('delete', `/company/${id}`),
  update: (data) => api('put', `/company/${data.id}`, data)
}